






















































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import AppSelect from "#/components/AppSelect.vue";

export interface PortalSearchParams {
  code?: string;
  name?: string;
  cst_no?: string;
  hst_no?: string;
  kst_no?: string;
  approval_statuses?: number[];
  listing_review_statuses?: number[];
  type?: number[];
  is_carelogood?: boolean | null;
  use_ibow?: boolean | null;
  use_carelogood?: boolean | null;
  use_jobsearch?: boolean | null;
  include_pending_join?: boolean; // true: use_carelogood / use_jobsearch の絞り込みに、そのサービスで参加申請中（保留）の事業所も含める
}

@Component({
  components: {
    AppTextField,
    AppSelect,
  },
})
export default class PortalSearchBox extends Vue {
  /** ボタンにつけるラベル名 */
  @Prop({ default: "" }) private forceService!: string;

  private code = "";
  private name = "";
  private cst_no = "";
  private hst_no = "";
  private kst_no = "";
  private selectedTypes = ["nursing", "medical"];
  private selectedCarelogood = [true];
  private selectedServices: string[] = [];

  private get noFieldCols() {
    if (!this.forceService) {
      return 4;
    }
    return 6;
  }

  private typeOptions = [
    { value: "nursing", text: "訪問看護" },
    { value: "medical", text: "医療機関" },
  ];

  private carelogoodOptions = [
    { value: true, text: "あり" },
    { value: false, text: "なし" },
  ];

  private allServiceOptions = [
    { value: "ibow", text: "iBow利用" },
    { value: "carelogood", text: "けあログっと利用" },
    { value: "jobsearch", text: "カエドキ利用" },
  ];

  private get serviceOptions() {
    if (!this.forceService) {
      return this.allServiceOptions;
    }
    return this.allServiceOptions.filter((option) => {
      return option.value != this.forceService;
    });
  }

  @Emit()
  private search(): PortalSearchParams {
    const typeValues: number[] = [];
    if (this.selectedTypes.includes("nursing")) {
      typeValues.push(1);
      typeValues.push(2);
    }
    if (this.selectedTypes.includes("medical")) {
      typeValues.push(3);
    }

    // 掲載側登録の複数選択処理
    let isCarelogood = null;
    if (
      this.selectedCarelogood.includes(true) &&
      !this.selectedCarelogood.includes(false)
    ) {
      // 「あり」のみ選択
      isCarelogood = true;
    } else if (
      this.selectedCarelogood.includes(false) &&
      !this.selectedCarelogood.includes(true)
    ) {
      // 「なし」のみ選択
      isCarelogood = false;
    }

    // 利用サービスの複数選択処理
    let useIbow = null;
    let useCarelogood = null;
    let useJobsearch = null;
    if (this.selectedServices.includes("ibow")) {
      useIbow = true;
    }
    if (
      this.selectedServices.includes("carelogood") ||
      this.forceService === "carelogood"
    ) {
      useCarelogood = true;
    }
    if (
      this.selectedServices.includes("jobsearch") ||
      this.forceService === "jobsearch"
    ) {
      useJobsearch = true;
    }

    const params: PortalSearchParams = {
      code: this.code,
      name: this.name,
      cst_no: this.cst_no,
      hst_no: this.hst_no,
      kst_no: this.kst_no,
      type: typeValues.length > 0 ? typeValues : undefined,
      is_carelogood: isCarelogood,
      use_ibow: useIbow,
      use_carelogood: useCarelogood,
      use_jobsearch: useJobsearch,
    };

    // サービス別の一覧（forceService 指定）からの検索では、追加の絞り込みの有無にかかわらず
    // そのサービスで参加申請中（保留）の事業所も含める（保留中は use_* が false のため）
    if (this.forceService) {
      params.include_pending_join = true;
    }

    return params;
  }
}
